// ************ ==== >>>>Root Routes <<<< ==== ************//
import { lazy } from "react";

const Login = lazy(() => import("../pages/website/Login"));
const SignUp = lazy(() => import("../pages/website/SignUp"));
const SignUpSuccess = lazy(() =>
  import("../pages/website/SignUp").then((mod) => ({ default: mod.SignUpSuccess })),
);
const Forgotpassword = lazy(() => import("../pages/website/Forgotpassword"));
const Resetpassword = lazy(() => import("../pages/website/Resetpassword"));
const Tender = lazy(() => import("../components/Tender/Tendermain"));
const MyBidList = lazy(() => import("../components/Tender/MyBidList"));
const TenderDetailPage = lazy(() => import("../components/Tender/TenderDetailpage"));
const UserProfile = lazy(() => import("../components/User/UserProfile"));
const PurchasePlan = lazy(() => import("../components/Pricing/PlanPurchase"));
const AccountDashboard = lazy(() => import("../pages/account/AccountDashboard"));
const AdminDashboard = lazy(() => import("../pages/adminDashboard/AdminDashboard"));
const EmployeeDashboard = lazy(() => import("../pages/employeeDashboard/EmployeeDashboard"));
const ContractorDashboard = lazy(() => import("../pages/contractorDashboard/ContractorDashboard"));
const TicketsManagement = lazy(() => import("../components/TicketsManagement/TicketsManagement"));
const TenderGuestDetail = lazy(() => import("../components/Tender/TenderGuest"));
const GuestTenderDetailPage = lazy(() => import("../components/Tender/GuestTenderDetailpage"));
const ContactUsData = lazy(() => import("../components/Tender/ContactUsData"));
const DemoEnquiriesAdmin = lazy(() => import("../components/Tender/DemoEnquiriesAdmin"));
const RequestDemo = lazy(() => import("../components/Tender/RequestDemo"));
const AllUsers = lazy(() => import("../components/Tender/AllUsers"));
const UserDashboard = lazy(() => import("../components/Pricing/UserDashboard"));
const TenderJatin = lazy(() => import("../pages/adminDashboard/tenderJatin/tender"));
const LandingPage = lazy(() => import("../pages/Landing Page/page"));
const Dashboard = lazy(() => import("../pages/adminDashboard/tenderJatin/adminDashboard"));
const Tendertrash = lazy(() => import("../components/Tender/TenderTrash"));
const TenderScrapper = lazy(() => import("../components/Tender/TenderScrapper"));
const CouponAdmin = lazy(() => import("../pages/adminDashboard/CouponAdmin"));
const HomepageShowcaseAdmin = lazy(
  () => import("../pages/adminDashboard/HomepageShowcaseAdmin"),
);
const QuoteRequestsAdmin = lazy(
  () => import("../pages/adminDashboard/QuoteRequestsAdmin"),
);
const MyQuotes = lazy(() => import("../components/Tender/MyQuotes"));
const RequestTenderManagement = lazy(() => import("../components/Tender/RequestTendermanagement"));
const PrivacyPolicy = lazy(() => import("../pages/website/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../pages/website/TermsAndConditions"));

const LEGAL_ROUTES = [
  {
    path: "privacypolicy",
    component: <PrivacyPolicy />,
  },
  {
    path: "terms",
    component: <TermsAndConditions />,
  },
];

const createAdminAiMantraWorkspace = (roleName) => ({
  role: roleName,
  isProtected: true,
  defaultRoute: `${roleName}/tenderlist`,
  nestedRoutes: [
    {
      routes: [
        {
          path: "landingpage",
          component: <LandingPage />,
        },
        {
          path: "tenderlist",
          component: <Tender />,
        },
        {
          path: "tenderList",
          component: <Tender />,
        },
        {
          path: "tenderscrapper",
          component: <TenderScrapper />,
        },
        {
          path: "tenderdetail",
          component: <TenderDetailPage />,
        },
        {
          path: "ticketSystem",
          component: <TicketsManagement />,
        },
        {
          path: "profilepage",
          component: <UserProfile />,
        },
        {
          path: "customersrequested",
          component: <RequestTenderManagement />,
        },
        {
          path: "contactusdata",
          component: <ContactUsData />,
        },
        {
          path: "demoenquiries",
          component: <DemoEnquiriesAdmin />,
        },
        {
          path: "allusers",
          component: <AllUsers />,
        },
        {
          path: "coupons",
          component: <CouponAdmin />,
        },
        {
          path: "quotes",
          component: <QuoteRequestsAdmin />,
        },
        {
          path: "homepageshowcase",
          component: <HomepageShowcaseAdmin />,
        },
        {
          path: "trashtender",
          component: <Tendertrash />,
        },
        {
          path: "dashboard",
          component: <Dashboard />,
        },
        ...LEGAL_ROUTES,
      ],
      path: roleName,
      component: <AdminDashboard />,
    },
  ],
});

export const routingData = [
  {
    role: "",
    isProtected: false,
    defaultRoute: "/login",
    routes: [
      {
        path: "/",
        component: <LandingPage />,
      },
      {
        path: "guesttenderdetails",
        component: <TenderGuestDetail />,
      },
      {
        path: "guesttenderdetail",
        component: <GuestTenderDetailPage />,
      },

      {
        path: "login",

        component: <Login />,
      },
      {
        path: "signup/success",
        component: <SignUpSuccess />,
      },
      {
        path: "signup",
        component: <SignUp />,
      },
      {
        path: "forgotpassword/",
        component: <Forgotpassword />,
      },
      {
        path: "resetpassword/:uidb64/:token/",
        component: <Resetpassword />,
      },
      {
        path: "resetpassword/",
        component: <Resetpassword />,
      },
      {
        path: "tenderList",
        component: <Tender />,
      },
      {
        path: "tenderjatin",
        component: <TenderJatin />,
      },
      {
        path: "requestdemo",
        component: <RequestDemo />,
      },
      {
        path: "privacypolicy",
        component: <PrivacyPolicy />,
      },
      {
        path: "terms",
        component: <TermsAndConditions />,
      },
    ],
  },
  {
    role: "9882641949",
    isProtected: true,
    defaultRoute: "employee/tenderlist",
    nestedRoutes: [
      {
        routes: [
          {
            path: "landingpage",
            component: <LandingPage />,
          },
          {
            path: "tenderList",
            component: <Tender />,
          },
          {
            path: "tenderdetail",
            component: <TenderDetailPage />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },

          {
            path: "pricing",
            component: <PurchasePlan />,
          },
          {
            path: "requestdemo",
            component: <RequestDemo />,
          },
          {
            path: "profilepage",
            component: <UserProfile />,
          },
          {
            path: "myquotes",
            component: <MyQuotes />,
          },
          ...LEGAL_ROUTES,
        ],
        path: "employee",
        component: <EmployeeDashboard />,
      },
    ],
  },
  {
    role: "aiadmin",
    isProtected: true,
    defaultRoute: "aiadmin/tenderlist",
    nestedRoutes: [
      {
        routes: [
          {
            path: "landingpage",
            component: <LandingPage />,
          },
          {
            path: "tenderList",
            component: <Tender />,
          },
          {
            path: "tenderscrapper",
            component: <TenderScrapper />,
          },
          {
            path: "tenderdetail",
            component: <TenderDetailPage />,
          },

          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "profilepage",
            component: <UserProfile />,
          },
          {
            path: "customersrequested",
            component: <RequestTenderManagement />,
          },
          {
            path: "contactusdata",
            component: <ContactUsData />,
          },
          {
            path: "demoenquiries",
            component: <DemoEnquiriesAdmin />,
          },
          {
            path: "allusers",
            component: <AllUsers />,
          },
          {
            path: "coupons",
            component: <CouponAdmin />,
          },
          {
            path: "quotes",
            component: <QuoteRequestsAdmin />,
          },
          {
            path: "homepageshowcase",
            component: <HomepageShowcaseAdmin />,
          },
          {
            path: "trashtender",
            component: <Tendertrash />,
          },
          {
            path: "dashboard",
            component: <Dashboard />,
          },
          ...LEGAL_ROUTES,
        ],
        path: "aiadmin",
        component: <AdminDashboard />,
      },
    ],
  },
  createAdminAiMantraWorkspace("Admin_AiMantra"),
  createAdminAiMantraWorkspace("Admin_Aimantra"),
  createAdminAiMantraWorkspace("SuperAdmin_AiMantra"),
  createAdminAiMantraWorkspace("SuperAdmin_Aimantra"),

  {
    role: "8700957700",
    isProtected: true,
    defaultRoute: "admin/tenderlist",
    nestedRoutes: [
      {
        routes: [
          {
            path: "landingpage",
            component: <LandingPage />,
          },
          {
            path: "tenderList",
            component: <Tender />,
          },
          {
            path: "tenderscrapper",
            component: <TenderScrapper />,
          },
          {
            path: "tenderdetail",
            component: <TenderDetailPage />,
          },

          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "profilepage",
            component: <UserProfile />,
          },

          {
            path: "customersrequested",
            component: <RequestTenderManagement />,
          },
          {
            path: "contactusdata",
            component: <ContactUsData />,
          },
          {
            path: "demoenquiries",
            component: <DemoEnquiriesAdmin />,
          },
          {
            path: "coupons",
            component: <CouponAdmin />,
          },
          {
            path: "quotes",
            component: <QuoteRequestsAdmin />,
          },
          {
            path: "homepageshowcase",
            component: <HomepageShowcaseAdmin />,
          },
          {
            path: "trashtender",
            component: <Tendertrash />,
          },
          ...LEGAL_ROUTES,
        ],
        path: "admin",
        component: <AdminDashboard />,
      },
    ],
  },

  {
    role: "Contractor",
    isProtected: true,
    defaultRoute: "contractor/tenderlist",
    nestedRoutes: [
      {
        routes: [
          {
            path: "landingpage",
            component: <LandingPage />,
          },
          {
            path: "tenderList",
            component: <Tender />,
          },
          {
            path: "tenderdetail",
            component: <TenderDetailPage />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },

          {
            path: "pricing",
            component: <PurchasePlan />,
          },
          {
            path: "requestdemo",
            component: <RequestDemo />,
          },
          {
            path: "profilepage",
            component: <UserProfile />,
          },
          {
            path: "mywishlist",
            component: <MyBidList />,
          },

          {
            path: "dashboard",
            component: <UserDashboard />,
          },
          {
            path: "myrequested",
            component: <RequestTenderManagement />,
          },
          {
            path: "myquotes",
            component: <MyQuotes />,
          },
          ...LEGAL_ROUTES,
        ],
        path: "contractor",
        component: <ContractorDashboard />,
      },
    ],
  },

  {
    role: "Accounts",
    isProtected: true,
    defaultRoute: "account/tenderlist",
    nestedRoutes: [
      {
        routes: [
          {
            path: "landingpage",
            component: <LandingPage />,
          },
          {
            path: "tenderList",
            component: <Tender />,
          },
          {
            path: "tenderdetail",
            component: <TenderDetailPage />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "profilepage",
            component: <UserProfile />,
          },
          {
            path: "myquotes",
            component: <MyQuotes />,
          },
          ...LEGAL_ROUTES,
        ],
        path: "account",
        component: <AccountDashboard />,
      },
    ],
  },
];
